import { render, staticRenderFns } from "./iconAdd.vue?vue&type=template&id=6f056893&scoped=true"
import script from "./iconAdd.vue?vue&type=script&lang=js"
export * from "./iconAdd.vue?vue&type=script&lang=js"
import style0 from "./iconAdd.vue?vue&type=style&index=0&id=6f056893&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f056893",
  null
  
)

export default component.exports